import { render, staticRenderFns } from "./ModalHistorialNuevo.vue?vue&type=template&id=675dd429&"
import script from "./ModalHistorialNuevo.vue?vue&type=script&lang=js&"
export * from "./ModalHistorialNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports